import { Input } from "design-react-kit";
import React, { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation } from "react-router-dom";
import Select from "../../Components/Select";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

import LabelsLoader from "../../Utility/labelsLoader";
import { TIPO_ISEE_RICHIESTO } from "../../Utility/tipoIsee";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditAnnouncement(props) {
  const apiToken = useContext(TokenContext);
  const d = new Date();
  const [serviceId, setServiceId] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [serviceName, setServiceName] = useState();
  const [ranges, setRanges] = useState([]);
  const [filterRange, setFilterRange] = useState("");

  const [validation, setValidation] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [servizioTemp, setServizioTemp] = useState();
  const [versioneServizio, setVersioneServizio] = useState([]);

  const labels = LabelsLoader();

  const STATI = [
    { label: "Creato", value: 0, code: "CREATE" },
    { label: "Aperto", value: 1, code: "OPEN" },
    { label: "Chiuso", value: 2, code: "CLOSED" },
    { label: "Archiviato", value: 3, code: "ARCHIVED" },
  ];
  const mapStateFromBackend = (code) =>
    STATI.find((s) => s.code === code)?.value ?? null;

  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState({});
  const [loadedRanges, setLoadedRanges] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("Tutti");

  let query = useQuery();


  const toggleRange = (id) => {
  setRanges((prev) =>
    prev.map((x) =>
      x.id === id
        ? { ...x, selected: !x.selected }
        : x
    )
  );
};

  useEffect(() => {
    if (apiToken) {
      setLoading(false);

      if (query.get("sessionId")) {
        Repo.getSessionByIdUser(apiToken, query.get("sessionId")).then(
          (response) => {
            const data = response.data;

            setSession({
              ...data,
              state: mapStateFromBackend(data.state), // 🔥 QUI RISOLVI TUTTO
              serviceId: data.service?.id ?? null,
              tipoIseeRichiesto:
                data.tipoIseeRichiesto ?? TIPO_ISEE_RICHIESTO.SOCIO_SANITARIO,
            });
          },
        );
      }

      Repo.getRangesList(apiToken)
        .then((response) => {
          const allRanges = response.data.map((x) => ({
            ...x,
            selected: false,
          }));

          setRanges(allRanges);
          setLoadedRanges(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

      Repo.getListaServizi(apiToken)
        .then((response) => {
          setServizi(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

      Repo.getSelectVersioneServizio(apiToken)
        .then((response) => {
          console.log("OK getSelectVersioneServizio:", response);
          setVersioneServizio(response.data);
        })
        .catch((error) =>
          console.error("Errore getSelectVersioneServizio:", error),
        )
        .finally(() => setLoading(true));
    }
  }, []);

  useEffect(() => {
    if (!session.bands || ranges.length === 0) return;

    setRanges((prev) =>
      prev.map((r) => ({
        ...r,
        selected: session.bands.some((b) => b.id === r.id),
      })),
    );
  }, [session.bands, ranges.length]);

  const checkSession = () => {
    setValidation(true);
    let passedValidation = true;

    const temp = {
      id: null,
      name: null,
      cost: null,
      serviceId: null,
      bandsId: [],
      state: null,
      year: null,
      externalId: null,
      codAccertamento: null,
      codCapitolo: null,
      nomeMyPay: null,
      tipoIseeRichiesto: TIPO_ISEE_RICHIESTO.SOCIO_SANITARIO,
      listBase64: [],
    };

    // ✅ SAFE CHECK (no crash)
    if (!session.serviceId && !session.service?.id) passedValidation = false;

    if (!session.name) passedValidation = false;
    if (!session.codAccertamento) passedValidation = false;
    if (!session.codCapitolo) passedValidation = false;
    if (!session.nomeMyPay) passedValidation = false;

    // 👉 bands safe
    temp.bandsId = ranges.filter((x) => x.selected).map((x) => x.id);

    temp.id = session.id;

    // 👉 serviceId safe
    temp.serviceId = session.service?.id ?? session.serviceId;

    temp.name = session.name;
    temp.codAccertamento = session.codAccertamento;
    temp.codCapitolo = session.codCapitolo;
    temp.nomeMyPay = session.nomeMyPay;
    temp.externalId = session.externalId;

    console.log("session.externalId:", session.externalId);

    // 🔥 FIX CRITICO
    temp.state = session.state; // DEVE GIÀ ESSERE NUMBER

    const parsedYear = parseInt(session.year, 10);
    temp.year = isNaN(parsedYear) ? null : parsedYear;

    temp.tipoIseeRichiesto =
      session.tipoIseeRichiesto === TIPO_ISEE_RICHIESTO.ORDINARIO
        ? TIPO_ISEE_RICHIESTO.ORDINARIO
        : TIPO_ISEE_RICHIESTO.SOCIO_SANITARIO;

    console.log("DTO pronto:", temp);

    // 👉 aggiorno session SOLO se valido
    if (passedValidation) {
      setSession(temp); // opzionale ma corretto
      toggleModal(!isOpen);
    }
  };

  const postUpdateSession = () => {
    console.log(JSON.stringify(session));
    Repo.postUpdateSession(apiToken, JSON.stringify(session))
      .then((response) => {
        if (response.status == 200) {
          window.location.href =
            props.subfolder +
            "/lista_bandi/bando?id=" +
            query.get("sessionId");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getGroupName = (name) => {
    return name
      .replace(/\s+MINORE.*$/i, "")
      .replace(/\s+MAGGIORE.*$/i, "")
      .replace(/\s+FINO(\s+A)?\s+.*$/i, "")
      .trim();
  };

  const gruppi = [
    "Tutti",
    ...new Set(ranges.map((x) => getGroupName(x.name))),
  ].sort();

  const filteredRanges = ranges.filter((x) => {
    const okGruppo =
      selectedGroup === "Tutti" || getGroupName(x.name) === selectedGroup;

    const okNome = x.name.toLowerCase().includes(filterRange.toLowerCase());

    return okGruppo && okNome;
  });

  const transferBlock = () => {
    return (
      <>
        <div className="row mt-4 mb-3">
          <div className="col-lg-4">
            <Select
              options={gruppi.map((x) => ({
                value: x,
                label: x,
              }))}
              value={{
                value: selectedGroup,
                label: selectedGroup,
              }}
              onChange={(e) => setSelectedGroup(e.value)}
              placeholder="Servizio"
            />
          </div>

          <div className="col-lg-4">
            <Input
              id="filterRange"
              label="Filtra fasce ISEE"
              type="text"
              value={filterRange || ""}
              placeholder="Cerca per nome..."
              onChange={(e) => setFilterRange(e.target.value)}
            />
          </div>

          <div className="col-lg-4 text-right align-self-end">
            <strong>
              {ranges.filter((x) => x.selected).length} fasce selezionate
            </strong>
          </div>
        </div>

        <div className="card card-bg no-after roundedCustom">
          <div className="card-body p-0">
            <table className="table table-hover mb-0">
              <thead>
                <tr>
                  <th style={{ width: "60px" }}></th>
                  <th>Fascia ISEE</th>
                  <th>Contributo</th>
                </tr>
              </thead>

              <tbody>
                {filteredRanges.length > 0 ? (
                  filteredRanges.map((x) => (
                    <tr
                      key={x.id}
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleRange(x.id)}
                    >
                      <td className="align-middle text-center">
                        <input
                          type="checkbox"
                          checked={!!x.selected}
                          onChange={() => toggleRange(x.id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </td>

                      <td className="align-middle">
  <strong>
    {Number(x.min).toLocaleString("it-IT")} €
    {" - "}
    {Number(x.max).toLocaleString("it-IT")} €
  </strong>
</td>

                     <td className="align-middle">
  {x.percent > 0 ? (
    <>
      <strong>{x.percent}%</strong>
      <br />
      <small className="text-muted">
        Max {Number(x.fixedCost).toLocaleString("it-IT")} €
      </small>
    </>
  ) : (
    <strong>
      {Number(x.fixedCost).toLocaleString("it-IT")} €
    </strong>
  )}
</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-4">
                      Nessuna fascia trovata
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {console.log(session.state || "")}
      <h1>Modifica bando</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Modifica il bando</p>
      </div>

      <div className="col-lg-12">
        <div className="card-wrapper card-space">
          <div className="card card-bg no-after roundedCustom">
            <div className="card-body p-5">
              <div className="row">
                <div className="col-lg-10">
                  <Input
                    id="title"
                    label="Titolo*"
                    type="text"
                    name="title"
                    value={session.name || session.name || ""}
                    onChange={(e) =>
                      setSession({ ...session, name: e.target.value })
                    }
                    {...(validation &&
                      !session.name && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
                <div className="col-lg-2">
                  <Input
                    type="number"
                    id="anno"
                    label="Anno"
                    name="anno"
                    value={session.year ?? ""}
                    onChange={(e) =>
                      setSession((prev) => ({
                        ...prev,
                        year: e.target.value, // ← STRINGA
                      }))
                    }
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-12">
                  <p className="mb-2 font-weight-semibold">
                    Tipologia ISEE richiesta*
                  </p>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="annTipoIseeSocio"
                      name="tipoIseeRichiesto"
                      value={TIPO_ISEE_RICHIESTO.SOCIO_SANITARIO}
                      checked={
                        (session.tipoIseeRichiesto ??
                          TIPO_ISEE_RICHIESTO.SOCIO_SANITARIO) ===
                        TIPO_ISEE_RICHIESTO.SOCIO_SANITARIO
                      }
                      onChange={() =>
                        setSession((prev) => ({
                          ...prev,
                          tipoIseeRichiesto: TIPO_ISEE_RICHIESTO.SOCIO_SANITARIO,
                        }))
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="annTipoIseeSocio"
                    >
                      Socio sanitario (se assente usa Ordinario)
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="annTipoIseeOrdinario"
                      name="tipoIseeRichiesto"
                      value={TIPO_ISEE_RICHIESTO.ORDINARIO}
                      checked={
                        session.tipoIseeRichiesto ===
                        TIPO_ISEE_RICHIESTO.ORDINARIO
                      }
                      onChange={() =>
                        setSession((prev) => ({
                          ...prev,
                          tipoIseeRichiesto: TIPO_ISEE_RICHIESTO.ORDINARIO,
                        }))
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="annTipoIseeOrdinario"
                    >
                      Solo Ordinario
                    </label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="bootstrap-select-wrapper col-lg-6">
                  <Select
                    aria-label="Servizio"
                    clearText="Annulla"
                    defaultMenuIsOpen={false}
                    icon={false}
                    name="servizio"
                    id="servizio"
                    options={servizi}
                    onChange={(e) => {
                      setServizioTemp(e ? e.label : null);
                      setSession({ ...session, serviceId: e.value });
                      setServiceName();
                    }}
                    isClearable
                    isSearchable
                    value={session.serviceId || ""}
                    placeholder={
                      servizioTemp
                        ? servizioTemp
                        : serviceName
                          ? serviceName
                          : session.service
                            ? session.service.name
                            : "Seleziona servizio*"
                    }
                  />
                  {validation && !session.serviceId ? (
                    <small id="errorSelect" className="form-text text-danger">
                      Il campo non può essere vuoto!
                    </small>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="bootstrap-select-wrapper col-lg-6">
                  <Select
                    aria-label="Stato bando"
                    options={STATI}
                    value={STATI.find((s) => s.value === session.state) || null}
                    onChange={(e) => {
                      setSession({
                        ...session,
                        state: e.value, // 🔥 NUMERO
                      });
                    }}
                    placeholder="Seleziona stato"
                  />

                  {validation && !session.state ? (
                    <small id="errorSelect" className="form-text text-danger">
                      Il campo non può essere vuoto!
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="row mt-4 mb-2">
                <div className="col-lg-4">
                  <Input
                    id="nomeMyPay"
                    label={labels.nomecampo1}
                    type="text"
                    name="nomeMyPay"
                    value={session.nomeMyPay || session.nomeMyPay || ""}
                    onChange={(e) =>
                      setSession({ ...session, nomeMyPay: e.target.value })
                    }
                    {...(validation &&
                      !session.nomeMyPay && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
                <div className="col-lg-4">
                  <Input
                    id="codAccertamento"
                    label="Codice Accertamento*"
                    type="text"
                    name="codAccertamento"
                    value={
                      session.codAccertamento || session.codAccertamento || ""
                    }
                    onChange={(e) =>
                      setSession({
                        ...session,
                        codAccertamento: e.target.value,
                      })
                    }
                    {...(validation &&
                      !session.codAccertamento && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
                <div className="col-lg-4">
                  <Input
                    id="codCapitolo"
                    label="Codice Capitolo*"
                    type="text"
                    name="codCapitolo"
                    value={session.codCapitolo || session.codCapitolo || ""}
                    onChange={(e) =>
                      setSession({ ...session, codCapitolo: e.target.value })
                    }
                    {...(validation &&
                      !session.codCapitolo && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
              </div>

              <div className="row  mb-2">
                <div className="bootstrap-select-wrapper col-lg-8">
                  <Select
                    aria-label={labels.versioneServizio}
                    name="externalId"
                    id="externalId"
                    options={[
                      { value: "", label: "Nessun valore" }, // Opzione vuota
                      ...versioneServizio,
                    ]}
                    value={
                      versioneServizio?.find(
                        (option) => option.value === session.externalId,
                      ) || { value: "", label: "Nessun valore" }
                    }
                    onChange={(e) => {
                      setSession({ ...session, externalId: e.value || null });
                    }}
                    placeholder="Seleziona modulo da associare"
                  />
                  {!session.externalId && (
                    <p className="text-muted">Nessun valore associato</p>
                  )}
                </div>
                <div className="col-lg-4">
                  <Input
                    id="externalId"
                    label={labels.versioneServizio}
                    type="text"
                    name="externalId"
                    readonly
                    value={session.externalId || null} // Mostra stringa vuota se il valore è null
                    onChange={(e) => {
                      const value = e.target.value || null; // Imposta null se il campo è vuoto
                      setSession({ ...session, externalId: value });
                    }}
                  />
                </div>
              </div>

              {transferBlock()}

              <div className="row mt-5">
                <div className="col-lg-12 text-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => checkSession()}
                    title="Conferma"
                  >
                    Conferma
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuovo bando"
        body="Confermi di voler modificare il bando?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => postUpdateSession()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default EditAnnouncement;
